import React, { useState } from "react";
import { FaVideo, FaVideoSlash } from "react-icons/fa"; // Import video icons
import * as webRTCHandler from "../../utils/webRTCHandler";

const CameraButton = () => {
  const [isLocalVideoDisabled, setIsLocalVideoDisabled] = useState(false);

  const handleCameraButtonPressed = () => {
    webRTCHandler.toggleCamera(!isLocalVideoDisabled);
    setIsLocalVideoDisabled(!isLocalVideoDisabled);
  };

  return (
    <div className="video_button_container" onClick={handleCameraButtonPressed}>
      {isLocalVideoDisabled ? (
        <FaVideoSlash className="video_button_icon active" />
      ) : (
        <FaVideo className="video_button_icon" />
      )}
    </div>
  );
};

export default CameraButton;
